// extracted by mini-css-extract-plugin
export default {"drawer":"CandidateInterviewNavigator_drawer__VNOqp"};